import { color, Stack } from "@chakra-ui/react";
import { NavSection } from "./NavSection";
import { NavLink } from "./NavLink";
import {
  RiDashboardLine,
  RiLogoutBoxLine,
  RiRefund2Fill,
} from "react-icons/ri";
import { BiUser, BiSupport } from "react-icons/bi";
import { ImFilesEmpty } from "react-icons/im";

import { useSidebarDrawer } from "../../context/SidebarDrawerContext";
import { useAuth } from "../../hooks/auth";

export function SidebarNav() {
  const { signOut } = useAuth();
  function handleLogOut() {
    signOut();
  }

  const { isOpen, onClose } = useSidebarDrawer();

  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        <NavLink
          as="li"
          icon={RiDashboardLine}
          href="/dashboard"
          children="Dashboard"
        />

        <NavLink as="li" icon={BiUser} href="/users" children="Usuários" />

        <NavLink
          as="li"
          icon={ImFilesEmpty}
          href="/registry"
          children="Registros"
        />

        {/* <NavLink
          as="li"
          icon={RiRefund2Fill}
          href="/request"
          children="Solicitações"
        /> */}

        <NavLink as="li" icon={BiSupport} href="/support" children="Suporte" />

        <NavLink
          as="li"
          icon={RiLogoutBoxLine}
          children="Sair"
          onClick={handleLogOut}
        />
      </NavSection>
    </Stack>
  );
}
